import { ISSMLCheckAudioError, ISSMLCheckTagError } from 'ssml-check'
import { capitalize } from 'lodash'

import { PropertySsmlValidationResult, SsmlValidationIssue } from '../types'
import { shouldIssueBeTreatedAsWarning, sortWarningsLast } from '../utils'

export function getSsmlValidationMessages(result?: PropertySsmlValidationResult): string[] {
  const messages = sortWarningsLast(result?.errors)?.map(verbalizeValidationIssue) ?? []

  // if (result?.fixedSSML) {
  //   messages.push(`Possible solution: "${result?.fixedSSML}"`)
  // }

  return messages
}

const getIssueCategory = (issue: SsmlValidationIssue) =>
  shouldIssueBeTreatedAsWarning(issue) ? 'warning' : 'error'

function verbalizeValidationIssue(issue: SsmlValidationIssue): string {
  const category = getIssueCategory(issue)

  switch (issue.type) {
    case 'tag': {
      const { tag, value, attribute } = issue as ISSMLCheckTagError
      return capitalize(`${category}: tag "${tag}" ${verbalizeValuePath(value, attribute)}`)
    }

    case 'audio': {
      const { value, detail } = issue as ISSMLCheckAudioError
      return capitalize(`${category}: "${detail}" with value "${value}"`)
    }

    default: {
      return capitalize(`${category}: ${issue.type}`)
    }
  }
}

function verbalizeValuePath(value?: string, attribute?: string): string {
  if (!value || !attribute) {
    return ''
  }

  return `with attribute "${attribute}" and value "${value}"`
}
